"use client";

import React from "react";
import { AlertCircle, X } from "lucide-react";
import { KYCProblem, getProblemDescription } from "@/types/models/kyc";

interface KYCErrorDisplayProps {
  problems?: KYCProblem[];
  rejectionReason?: string;
  onClose?: () => void;
  className?: string;
}

export const KYCErrorDisplay: React.FC<KYCErrorDisplayProps> = ({
  problems = [],
  rejectionReason,
  onClose,
  className = "",
}) => {
  if (problems.length === 0 && !rejectionReason) {
    return null;
  }

  return (
    <div className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-start">
        <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">
            KYC Verification Issues
          </h3>
          
          {/* General rejection reason */}
          {rejectionReason && (
            <div className="mt-2">
              <p className="text-sm text-red-700">{rejectionReason}</p>
            </div>
          )}

          {/* Specific field problems */}
          {problems.length > 0 && (
            <div className="mt-2">
              <p className="text-sm text-red-700 font-medium mb-2">
                Please fix the following issues:
              </p>
              <ul className="space-y-1">
                {problems.map((problem, index) => (
                  <li key={index} className="text-sm text-red-700">
                    • {getProblemDescription(problem)}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="mt-3">
            <p className="text-xs text-red-600">
              Please update the highlighted fields and resubmit for verification.
            </p>
          </div>
        </div>
        
        {onClose && (
          <button
            onClick={onClose}
            className="ml-3 flex-shrink-0 text-red-400 hover:text-red-600"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default KYCErrorDisplay;